<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>{{ 'reports.exports.fast.shortLabel' | translate }}</h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form *ngIf="simulations && years" [formGroup]="selectForm" (ngSubmit)="getReport()">
            <mat-form-field>
                <mat-label>{{ 'reports.compare.select.shortLabel' | translate }}</mat-label>
                <mat-select formControlName="simulation">
                    <mat-option *ngFor="let simulation of simulations" [value]="simulation.code">
                        {{ simulation.text.shortLabel }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{ 'reports.compare.years.shortLabel' | translate }}</mat-label>
                <mat-select formControlName="year">
                    <mat-option *ngFor="let year of years" [value]="year">
                        {{ year }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <button *ngIf="!isLoading" mat-raised-button color="accent" type="submit" [disabled]="!simulations || selectForm.invalid">
                {{ 'reports.exports.crac.shortLabel' | translate }}
            </button>
            <mat-spinner *ngIf="isLoading" [diameter]="35" color="accent" class="spinner"></mat-spinner>
        </form>
        <mat-spinner *ngIf="!simulations" [diameter]="35" color="accent" class="spinner"></mat-spinner>
    </mat-card-content>
</mat-card>
